import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Flex, Space, Typography } from 'antd'
import { type FC, type ReactNode } from 'react'

interface PageHeaderProps {
  title?: ReactNode
  extra?: ReactNode
  onBack?: () => void
  className?: string
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  extra,
  onBack,
  className
}) => (
  <Flex
    align='center'
    justify='space-between'
    wrap
    gap={16}
    className={className}
  >
    {(title != null || onBack != null) && (
      <Flex align='center' gap={12} style={{ minWidth: 0 }}>
        {onBack != null && (
          <Button
            type='text'
            aria-label='Go back'
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
          />
        )}
        {title != null && (
          <Typography.Title
            level={4}
            style={{ margin: 0, overflowWrap: 'anywhere' }}
          >
            {title}
          </Typography.Title>
        )}
      </Flex>
    )}
    {extra != null && (
      <Flex
        gap={8}
        style={{ marginInlineStart: 'auto', minWidth: 0, maxWidth: '100%' }}
      >
        <Space>{extra}</Space>
      </Flex>
    )}
  </Flex>
)
